import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { prepaymentsreports } from '../../services/reportservice';
import { setLoading } from "../../redux/appSlice";
import { useHistory } from "react-router-dom";
import { valdiatePage } from "../../global";
import Pagination from '../../components/paginations';
import SeeMoreModal from "../../components/SeeMoreModal";
import ExportExcelButton from "../../components/exportExcelButton";

const PrePayments = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { userInfo, accounts } = useSelector((state) => state.appData);

  const [data, setData] = useState({ accountNo: "" });
  const [grid, setGrid] = useState([]);
  const [originalGrid, setOriginalGrid] = useState([]);

  const [page, setPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(50);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "ascending" });

  const searchObjInit = {
    ZoneName: "",
    BranchName: "",
    BenName: "",
    BenAccNo: "",
    AvailableAmt: "",
    InvoiceAmt: "",
    NetPayable: "",
  };

  const [searchObject, setSearchObj] = useState(searchObjInit);
  const updateSearchData = (key, val) => setSearchObj((prev) => ({ ...prev, [key]: val }));

  const gridKeys = [
    { key: "ZoneName", name: "Zone Name", searchBox: true, visible: true },
    { key: "BranchName", name: "Branch Name", searchBox: true, visible: true },
    { key: "creditClientId", name: "Credit Client ID", searchBox: false, visible: true },
    { key: "AccNo", name: "Account Number", searchBox: false, visible: true },
    { key: "AccName", name: "Account Name", searchBox: false, visible: true },
    { key: "BenName", name: "Beneficiary Name", searchBox: true, visible: true },
    { key: "BenAccNo", name: "Beneficiary Account No", searchBox: true, visible: true },
    { key: "BenBank", name: "Beneficiary Bank", searchBox: false, visible: true },
    { key: "BenBankCode", name: "Beneficiary Bank Code", searchBox: false, visible: true },
    { key: "AvailableAmt", name: "Available AMT", searchBox: true, visible: true },
    { key: "InvoiceAmt", name: "Invoice AMT", searchBox: true, visible: true },
    { key: "NetPayable", name: "Net Payable", searchBox: true, visible: true },
  ];

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  let filterData = useMemo(() => {
    return grid.filter(
      (item, index) => index >= page * pageLimit && index < (page + 1) * pageLimit
    );
  }, [page, grid, pageLimit, grid.length]);

  const sortedArray = [...filterData].sort((a, b) => {
    if (!sortConfig.key) return 0;
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? 1 : -1;
    }
    return 0;
  });

  useEffect(() => {
    if (!valdiatePage("/premayments")) {
      history.push("/login");
    }
  }, [history]);

  const getReport = async (accountNo) => {
    setData((prev) => ({ ...prev, accountNo }));

    if (!accountNo) {
      alert("Enter Account No");
      return;
    }

    dispatch(setLoading({ data: true }));
    const rs = await prepaymentsreports(accountNo);
    dispatch(setLoading({ data: false }));

    if (rs.ok) {
      setGrid(rs.data);
      setOriginalGrid(rs.data);
    } else {
      setGrid([]);
      alert("No Data Found");
    }
  };


  const exportHeaders = [
    { label: "Zone Name", key: "ZoneName" },
    { label: "Branch Name", key: "BranchName" },
    { label: "Credit Client ID", key: "creditClientId" },
    { label: "Account Number", key: "AccNo" },
    { label: "Account Name", key: "AccName" },
    { label: "Beneficiary Name", key: "BenName" },
    { label: "Beneficiary Account No", key: "BenAccNo" },
    { label: "Beneficiary Bank", key: "BenBank" },
    { label: "Beneficiary Bank Code", key: "BenBankCode" },
    { label: "Available AMT", key: "AvailableAmt" },
    { label: "Invoice AMT", key: "InvoiceAmt" },
    { label: "Net Payable", key: "NetPayable" },
  ];

  return (
    userInfo && (
      <section className="section">
        <div className="section-header">
          <h1>Pre Payments</h1>
        </div>

        <div className="card" style={{ padding: 10 }}>
          <div className="row">
            <div className="col-lg-3">
              <label>Sub Account</label>
              <select
                className="form-select"
                value={data.accountNo}
                onChange={(e) => getReport(e.target.value)}
              >
                <option value="">Select Account</option>
                {accounts.map((x, index) => (
                  <option key={index} value={x}>
                    {x}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {originalGrid && originalGrid.length > 0 && (
            <div className="row mt-3">
              <div style={{ textAlign: "right", marginBottom: "5px" }}>
                <ExportExcelButton data={originalGrid} columns={exportHeaders} fileName="PrePaymentsReport"/>

              </div>

              <Pagination
                setGrid={setGrid}
                searchObjInit={searchObjInit}
                searchObject={searchObject}
                originalGrid={originalGrid}
                setPage={setPage}
                setPageLimit={setPageLimit}
                requestSort={requestSort}
                sortConfig={sortConfig}
                updateSearchData={updateSearchData}
                sortedArray={sortedArray}
                data={data}
                dataCount={grid.length}
                pageLimit={pageLimit}
                gridKeys={gridKeys}
                page={page}
                grid={
                  sortedArray && sortedArray.length > 0 ? (
                    sortedArray.map((x, index) => (
                      <tr key={index}>
                        <td>{index + 1 + page * pageLimit}</td>
                        <td>{x.ZoneName}</td>
                        <td>{x.BranchName}</td>
                        <td>{x.creditClientId}</td>
                        <td>{x.AccNo}</td>
                        <td style={{ minWidth: 200 }}>
                          <SeeMoreModal detail={x.AccName} maxLength={80} />
                        </td>
                        <td style={{ minWidth: 200 }}>
                          <SeeMoreModal detail={x.BenName} maxLength={80} />
                        </td>
                        <td style={{ minWidth: 200 }}>{x.BenAccNo}</td>
                        <td style={{ minWidth: 200 }}>
                          <SeeMoreModal detail={x.BenBank} maxLength={80} />
                        </td>
                        <td>{x.BenBankCode}</td>
                        <td>{x.AvailableAmt}</td>
                        <td>{x.InvoiceAmt}</td>
                        <td>{x.NetPayable}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3}>No Record Found</td>
                    </tr>
                  )
                }
              />
            </div>
          )}
        </div>
      </section>
    )
  );
};

export default PrePayments;
